module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074f1_logo_200x200.d4a6d169.png";